import { __read, __spread, __values } from "tslib";
import { Listener } from "./Listener.mjs";
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this._eventListeners = new Map();
        this._internalEventListeners = new Map();
    }
    EventEmitter.prototype.on = function (event, listener) {
        return this._addListener(false, event, listener);
    };
    EventEmitter.prototype.addListener = function (event, listener) {
        return this._addListener(false, event, listener);
    };
    EventEmitter.prototype.removeListener = function (idOrEvent, listener) {
        this._removeListener(false, idOrEvent, listener);
    };
    EventEmitter.prototype.registerEvent = function () {
        var _this = this;
        var eventBinder = function (handler) { return _this.addListener(eventBinder, handler); };
        return eventBinder;
    };
    EventEmitter.prototype.emit = function (event) {
        var e_1, _a, e_2, _b;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this._eventListeners.has(event)) {
            try {
                for (var _c = __values(this._eventListeners.get(event)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var listener = _d.value;
                    listener.apply(void 0, __spread(args));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (this._internalEventListeners.has(event)) {
            try {
                for (var _e = __values(this._internalEventListeners.get(event)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var listener = _f.value;
                    listener.apply(void 0, __spread(args));
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    EventEmitter.prototype.registerInternalEvent = function () {
        var _this = this;
        var eventBinder = function (handler) { return _this.addInternalListener(eventBinder, handler); };
        return eventBinder;
    };
    EventEmitter.prototype.addInternalListener = function (event, listener) {
        return this._addListener(true, event, listener);
    };
    EventEmitter.prototype.removeInternalListener = function (idOrEvent, listener) {
        this._removeListener(true, idOrEvent, listener);
    };
    EventEmitter.prototype._addListener = function (internal, event, listener) {
        var listenerMap = internal ? this._eventListeners : this._internalEventListeners;
        if (listenerMap.has(event)) {
            listenerMap.get(event).push(listener);
        }
        else {
            listenerMap.set(event, [listener]);
        }
        return new Listener(this, event, listener, internal);
    };
    EventEmitter.prototype._removeListener = function (internal, idOrEvent, listener) {
        var listenerMap = internal ? this._eventListeners : this._internalEventListeners;
        if (!idOrEvent) {
            listenerMap.clear();
        }
        else if (typeof idOrEvent === 'object') {
            var id = idOrEvent;
            this._removeListener(id._internal, id.event, id.listener);
        }
        else {
            var event = idOrEvent;
            if (listenerMap.has(event)) {
                if (listener) {
                    var listeners = listenerMap.get(event);
                    var idx = 0;
                    while ((idx = listeners.indexOf(listener)) !== -1) {
                        listeners.splice(idx, 1);
                    }
                }
                else {
                    listenerMap.delete(event);
                }
            }
        }
    };
    return EventEmitter;
}());
export { EventEmitter };
